// Mock implementation of @react-native-firebase/app-check for web
// Firebase web SDK handles app check differently

const appCheck = () => ({
  newReactNativeFirebaseAppCheckProvider: () => ({
    configure: () => {},
  }),
  initializeAppCheck: () => Promise.resolve(),
  getToken: () => Promise.resolve({ token: "web-mock-token" }),
})

export default appCheck
